import React, {ReactElement, useEffect, useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  ListItemText,
  MenuItem,
  Select,
  Link,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';
import Loader from '@components/framework/loader/Loader';
import DragAndDrop from '@components/system/DragAndDrop/DragAndDrop';
import {FilterClinicStyles} from '../Invoices/DueInvoices/DueInvoices';
import DateTimePickerWrapper from '@components/system/CustomDateTimePicker/DateTimePickerWrapper';
import {textFieldStyles} from '../Invoices/TableDataAndStyles';
import {useSnackbar} from 'notistack';
import moment from 'moment';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import CustomSelectField from '../ClinicGroups/AddUser/CustomSelectField';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
  importInvoices,
  importPatients,
  importStatementTypes,
  importPatientCopay,
  importAppointments,
  importVoucherLocationMapping
} from '@shared/services/EMRProviderServices';
import {downloadFNPDTemplate} from '@shared/services/DueInvoiceServices';
import './ImportDialogStyles.scss';
import {
  AppPermissions,
  EMRProviderIDs,
  EMRProviders,
  IMPORT_TYPES
} from '@shared/constants/Mapping';
import {getClinicDetails} from '@shared/services/ClinicServices';
import {useSelector} from 'react-redux';
import {Permission} from '@shared/services/PermissionService';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import HelperUtils from '@shared/utils/HelperUtils';
import {
  MAX_PATIENT_FILE_SIZES,
  TEMPLATE_FILE_NAMES
} from 'src/constants/SystemConstants';
import {
  getGenericEmrStatementTemplateFile,
  getGenericPatientTemplateFile
} from '@shared/services/CommonServices';

// import { FormatColorReset } from '@material-ui/icons';

// interface for Confirmation Dialog props
interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  subtitle: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onClose(response: 'confirm' | 'cancel'): void;
  clinics: any[];
  groupId: string | number;
  importType: string;
  selectFileTitle: string;
  patientShared?: boolean | number | undefined;
  handleFlag?: any;
}

const ImportFileDialog = (
  props: ConfirmationDialogProps
): React.ReactElement => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const ClinicClasses = FilterClinicStyles();
  const classes = textFieldStyles();
  const [loader, setLoader] = useState<boolean>(false);
  const [importedFile, setImportedFile] = useState<any>(null);
  const [settledDate, setSettledDate] = useState<any>(moment());
  const [selectedClinic, setSelectedClinic] = useState<any>();
  const [selectedClinicMinMonth, setSelectedClinicMinMonth] = useState<
    number | undefined
  >();
  const [selectedClinicMinYear, setSelectedClinicMinYear] = useState<
    number | undefined
  >();
  const [overrideStatement, setOverrideStatements] = useState<string>('');
  const [
    showOverrideConfirmation,
    setShowOverrideConfirmation
  ] = useState<boolean>(false);
  const [fileSizeError, setFileSizeError] = useState('');

  const userPermissions: any = useSelector(
    (state: any) => state.auth.userPermissions || {}
  );

  const consolidatedBillingGroupEnable: boolean = useSelector(
    (state: any) => state.clinics.consolidatedBillingGroupEnable
  );
  const billingClinicId: number = useSelector(
    (state: any) => state.clinics.billingClinicId
  );

  const showBillingPractice: any = useSelector(
    (state: any) => state.clinics.showBillingPractice
  );

  const [openDialog, setOpenDialog] = useState(false);
  // props de-structure
  const {
    open,
    onClose,
    title,
    subtitle,
    cancelButtonText,
    confirmButtonText,
    clinics,
    groupId,
    importType,
    selectFileTitle,
    patientShared,
    handleFlag
  } = props;

  const groups = useSelector((state: any) => state.auth.userGroups);
  const selectedGroup = groups.find((g: any) => g.id === groupId);
  const groupEmrProvider = selectedGroup?.emr_provider;
  const groupPatientShared = selectedGroup?.patients_shared;

  const downloadFile = ({
    fileToDownload,
    fileContentType = 'arraybuffer',
    fileName = ''
  }: {
    fileToDownload: any;
    fileName?: string;
    fileContentType?: string;
  }) => {
    try {
      const url = window.URL.createObjectURL(
        new Blob([fileToDownload], {type: fileContentType})
      );
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.setAttribute('download', fileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      throw new Error('Error in downloading the file');
    }
  };

  const handleDownloadModuleTemplateFile = async () => {
    try {
      if (importType === IMPORT_TYPES.PATIENTS) {
        const res = await getGenericPatientTemplateFile();
        const contentType = res.headers['content-type'];
        downloadFile({
          fileToDownload: res.data,
          fileContentType: contentType,
          fileName: TEMPLATE_FILE_NAMES.GENERIC_PATIENTS_FILE_NAME
        });
      } else if (importType === IMPORT_TYPES.STATEMENTS) {
        const res = await getGenericEmrStatementTemplateFile();
        const contentType = res.headers['content-type'];
        downloadFile({
          fileToDownload: res.data,
          fileContentType: contentType,
          fileName: TEMPLATE_FILE_NAMES.GENERIC_STATEMENTS_FILE_NAME
        });
      }
    } catch (err: any) {
      enqueueSnackbar(err?.message, SnackBarConfig('e'));
    }
  };

  const handleDownloadFNPDTemplate = async (): Promise<void> => {
    try {
      downloadFNPDTemplate()
        .then((res: any) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'final_notice_and_past_due.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch((error: any) => {
          enqueueSnackbar(t(error.message), SnackBarConfig('e'));
          throw error;
        });
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  const resetStateData = () => {
    setImportedFile(null);
    setSettledDate(new Date());
    setSelectedClinicMinMonth(undefined);
    setSelectedClinicMinYear(undefined);
    setSelectedClinic(null);
    setShowOverrideConfirmation(false);
    setOverrideStatements('');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleClinicSelect = (clinic: any): void => {
    if (clinic.id == selectedClinic?.id) {
      return;
    }
    setSelectedClinic(clinic);
    if (importType === IMPORT_TYPES.STATEMENTS) {
      if (
        !Permission.hasIncomingSmsPermissions(
          userPermissions,
          AppPermissions.CLINIC.READ,
          groupId
        )
      ) {
        return;
      }
      getClinicDetails({
        groupId: clinic.org_group_id,
        clinicId: clinic.id,
        fetch_last_imported_month: true
      })
        .then(res => {
          if (res?.data) {
            const {
              statement_month: statementMonth,
              statement_year: statementYear
            } = res?.data?.guarantorDues ?? {};
            setSelectedClinicMinMonth(statementMonth);
            setSelectedClinicMinYear(statementYear);
            setSettledDate(moment());
            setShowOverrideConfirmation(
              importType === IMPORT_TYPES.STATEMENTS &&
                statementYear == moment()?.year() &&
                statementMonth == (moment()?.month() ?? 0) + 1
            );
          }
        })
        .catch(error => {
          enqueueSnackbar(error.message, SnackBarConfig('e'));
        });
    }
  };
  const handleSelectedRadio = (val: string) => {
    setOverrideStatements(val);
  };
  useEffect(() => {
    if (
      clinics?.length === 1 &&
      !(
        importType === IMPORT_TYPES.STATEMENTS &&
        consolidatedBillingGroupEnable &&
        billingClinicId &&
        showBillingPractice
      )
    ) {
      handleClinicSelect(clinics[0]);
    }
    if (importType === IMPORT_TYPES.STATEMENTS) {
      if (
        consolidatedBillingGroupEnable &&
        billingClinicId &&
        showBillingPractice &&
        clinics.length > 0
      ) {
        const billingClinic = clinics.find(
          (clinic: any) => clinic.id === billingClinicId
        );
        if (billingClinic) {
          handleClinicSelect(billingClinic);
        } else {
          setSelectedClinic(null);
          enqueueSnackbar(
            t('DUE_INVOICES.ERRORS.NO_BILLING_CLINIC_ACCESS'),
            SnackBarConfig('e')
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    billingClinicId,
    clinics,
    consolidatedBillingGroupEnable,
    handleClinicSelect,
    importType,
    showBillingPractice
  ]);

  const importClinicGroupInvoices = async (
    data: any,
    clinic: any
  ): Promise<void> => {
    if (!clinic) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_A_CLINIC'),
        SnackBarConfig('e')
      );
      return;
    }
    if (!settledDate) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_STATEMENT_YEAR_MONTH'),
        SnackBarConfig('e')
      );
      return;
    }
    const checkDate = moment('01-01-1979', 'mm-dd-yyyy').startOf('month');
    if (selectedClinicMinYear) {
      checkDate.year(selectedClinicMinYear);
    }
    if (selectedClinicMinMonth) {
      checkDate.month(selectedClinicMinMonth - 1);
    }
    if (
      moment(settledDate).diff(checkDate) < 0 ||
      moment().diff(moment(settledDate)) < 0
    ) {
      enqueueSnackbar('Invalid date', SnackBarConfig('e'));
      return;
    }
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    const month = settledDate?.month();
    const year = settledDate?.year();
    importInvoices(
      groupId,
      clinic.id,
      data,
      typeof month != 'undefined' ? month + 1 : month,
      year,
      overrideStatement !== 'no'
    )
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('i'));
          resetStateData();
          setOpenDialog(false);
          onClose('confirm');
          handleFlag(true);
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const importClinicGroupStatementUpdate = async (
    data: any,
    clinic: any
  ): Promise<void> => {
    if (!clinic) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_A_CLINIC'),
        SnackBarConfig('e')
      );
      return;
    }
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    importStatementTypes(groupId, clinic.id, data)
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('s'));
          resetStateData();
          onClose('confirm');
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const importClinicGroupPatients = async (
    data: any,
    clinic?: any
  ): Promise<void> => {
    if (!patientShared && !clinic) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_A_CLINIC'),
        SnackBarConfig('e')
      );
      return;
    }
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    importPatients(groupId, data, clinic?.id)
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('i'));
          resetStateData();
          onClose('confirm');
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const importClinicGroupPatientCopay = async (
    data: any,
    clinic?: any
  ): Promise<void> => {
    if (!patientShared && !clinic) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_A_CLINIC'),
        SnackBarConfig('e')
      );
      return;
    }
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    importPatientCopay(groupId, data, clinic?.id)
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('i'));
          resetStateData();
          onClose('confirm');
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const importClinicGroupAppointments = async (
    data: any,
    clinic?: any
  ): Promise<void> => {
    if (!clinic) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.SELECT_A_CLINIC'),
        SnackBarConfig('e')
      );
      return;
    }
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    importAppointments(groupId, data, clinic?.id)
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('i'));
          resetStateData();
          onClose('confirm');
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const importVoucherLocationMappingFile = async (
    data: any
    // clinic?: any
  ): Promise<void> => {
    if (!data) {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.PLEASE_UPLOAD_FILE'),
        SnackBarConfig('e')
      );
      return;
    }
    setLoader(true);
    importVoucherLocationMapping(groupId, data)
      .then(response => {
        if (response) {
          enqueueSnackbar(response.message, SnackBarConfig('i'));
          resetStateData();
          onClose('confirm');
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
        // throw error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleClose = (response: 'confirm' | 'cancel') => {
    if (response === 'confirm') {
      if (clinics.length !== 1) {
        if (importType === IMPORT_TYPES.STATEMENTS) {
          importClinicGroupInvoices(importedFile, selectedClinic);
        } else if (importType === IMPORT_TYPES.FNPD) {
          importClinicGroupStatementUpdate(importedFile, selectedClinic);
        } else if (importType === IMPORT_TYPES.PATIENTS) {
          importClinicGroupPatients(importedFile, selectedClinic);
        } else if (importType === IMPORT_TYPES.PATIENT_COPAY) {
          importClinicGroupPatientCopay(importedFile, selectedClinic);
        } else if (importType === IMPORT_TYPES.APPOINTMENTS) {
          importClinicGroupAppointments(importedFile, selectedClinic);
        } else if (importType === IMPORT_TYPES.VOUCHER_NUMBER) {
          importVoucherLocationMappingFile(importedFile);
        }
      } else if (clinics.length === 1) {
        if (importType === IMPORT_TYPES.STATEMENTS) {
          importClinicGroupInvoices(importedFile, clinics[0]);
        } else if (importType === IMPORT_TYPES.FNPD) {
          importClinicGroupStatementUpdate(importedFile, clinics[0]);
        } else if (importType === IMPORT_TYPES.PATIENTS) {
          importClinicGroupPatients(importedFile, clinics[0]);
        } else if (importType === IMPORT_TYPES.PATIENT_COPAY) {
          importClinicGroupPatientCopay(importedFile, clinics[0]);
        } else if (importType === IMPORT_TYPES.APPOINTMENTS) {
          importClinicGroupAppointments(importedFile, clinics[0]);
        } else if (importType === IMPORT_TYPES.VOUCHER_NUMBER) {
          importVoucherLocationMappingFile(importedFile);
        }
      }
    } else if (response === 'cancel') {
      resetStateData();
      onClose(response);
    }
  };

  const getInputFile = (files: any): void => {
    const data = new FormData();
    const file = files[0];
    if (!file) {
      return setImportedFile(null);
    }
    if (importType === IMPORT_TYPES.PATIENTS) {
      const fileExtension = file.name.split('.').slice(-1)[0];
      if (file.size > MAX_PATIENT_FILE_SIZES[fileExtension]?.bytes) {
        setFileSizeError(
          t('PATIENTS.PATIENT_UPLOAD_SIZE_LIMIT_EXCEEDED', {
            fileExtension,
            fileSize: MAX_PATIENT_FILE_SIZES[fileExtension]?.formattedSize
          })
        );
      } else {
        setFileSizeError('');
      }
    }
    data.append('inputname', file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      if (file.size === 0) {
        enqueueSnackbar(t('ADD_CLINIC.EMPTY_FILE'), SnackBarConfig('w'));
      } else {
        setImportedFile(data);
      }
    };
  };

  const renderStatementMonthAndYear = (): ReactElement => {
    const minDate = moment('01-01-1979', 'mm-dd-yyyy');
    const maxDate = moment();

    if (selectedClinicMinMonth) {
      minDate.month(selectedClinicMinMonth - 1);
    }
    if (selectedClinicMinYear) {
      minDate.year(selectedClinicMinYear);
    }
    minDate.startOf('month');

    return (
      <DateTimePickerWrapper
        style={{width: '100%', height: '3.125rem'}}
        views={['month', 'year']}
        disabled={clinics.length === 1 ? !clinics[0] : !selectedClinic}
        format={'MM/yyyy'}
        value={settledDate}
        placeholder={t('DUE_INVOICES.PLACEHOLDERS.STATEMENT_MONTH_AND_YEAR')}
        onChange={date => {
          setOverrideStatements('');
          if (date?.toDate()) {
            setSettledDate(date);
            setShowOverrideConfirmation(
              importType === IMPORT_TYPES.STATEMENTS &&
                selectedClinicMinYear == date?.year() &&
                selectedClinicMinMonth == (date?.month() ?? 0) + 1
            );
          } else {
            setSettledDate(moment());
            setShowOverrideConfirmation(
              importType === IMPORT_TYPES.STATEMENTS &&
                selectedClinicMinYear == moment()?.year() &&
                selectedClinicMinMonth == (moment()?.month() ?? 0) + 1
            );
          }
        }}
        className={[
          classes.root,
          classes.adornedEnd,
          classes.dateInputStyle
        ].join(' ')}
        minDate={minDate}
        maxDate={maxDate}
      />
    );
  };

  const renderClinicSelect = (): ReactElement => {
    const disableClinic =
      clinics.length === 1 ||
      (importType === IMPORT_TYPES.STATEMENTS &&
        consolidatedBillingGroupEnable &&
        billingClinicId &&
        showBillingPractice);

    return (
      <div
        className="filters-view"
        data-test-id="pcl-import-selectPracticeDropDown">
        <div className="label">{t('COMMON.SELECT_CLINIC_IMPORT')}</div>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={
            selectedClinic
              ? [selectedClinic?.name]
              : [t('DUE_INVOICES.PLACEHOLDERS.SELECT_CLINIC')]
          }
          variant="outlined"
          style={disableClinic ? {opacity: 0.5} : {}}
          disabled={disableClinic}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}>
          <div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {clinics.map((clinic: any) => (
                <MenuItem
                  key={clinic.id}
                  value={clinic.name}
                  onClick={(): void => {
                    handleClinicSelect(clinic);
                  }}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic.name}
                    secondary={
                      <>
                        {clinic.emr_provider_detail?.name && (
                          <>
                            <span
                              className={
                                ClinicClasses.clinicMenuEmrProviderText
                              }>
                              {clinic.emr_provider_detail?.name}
                            </span>
                            &nbsp;/&nbsp;
                          </>
                        )}
                        <span>
                          {clinic.city}, {clinic.country}
                        </span>
                      </>
                    }
                  />
                  <Radio checked={selectedClinic?.id === clinic.id} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <div>
        <div className={ClinicClasses.importClinicClass}>
          {(importType === IMPORT_TYPES.PATIENTS ||
            importType === IMPORT_TYPES.VOUCHER_NUMBER) &&
          patientShared
            ? ''
            : renderClinicSelect()}
        </div>
        {importType === IMPORT_TYPES.STATEMENTS && (
          <div className={ClinicClasses.addDate}>
            <div className={ClinicClasses.labelPosition}>
              {t('DUE_INVOICES.HEADERS.SELECT_STATEMENT_MONTH_AND_YEAR')}
              :&nbsp; &nbsp;
            </div>
            {renderStatementMonthAndYear()}
          </div>
        )}
        <div className={ClinicClasses.importClinicClass}>
          <div className={ClinicClasses.labelPosition}>
            {selectFileTitle}
            :&nbsp; &nbsp;
          </div>
          <DragAndDrop
            title={
              <Trans
                i18nKey={'COMMON.UPLOAD_FILE'}
                components={[
                  <label className="drop-title" key={'X'} />,
                  <span className="drop-title" key={'Y'} />,
                  <span className="drop-title" key={'Z'} />
                ]}
              />
            }
            multiple={false}
            showSelectedFile
            handleFileChange={getInputFile}
            acceptFileTypes={
              importType === IMPORT_TYPES.VOUCHER_NUMBER
                ? '.xlsx,.csv'
                : '.xlsx,.xls,.csv,.tsv,.txt,.xml'
            }
          />
          {[IMPORT_TYPES.PATIENTS, IMPORT_TYPES.STATEMENTS].includes(
            importType
          ) &&
            ((!groupPatientShared &&
              selectedClinic?.emr_provider_detail?.name ===
                EMRProviders.GENERIC) ||
              (groupPatientShared &&
                groupEmrProvider === EMRProviderIDs.GENERIC)) && (
              <Link
                component="button"
                style={{marginTop: '0.5rem'}}
                onClick={() => {
                  handleDownloadModuleTemplateFile();
                }}>
                {t('PATIENTS.DOWNLOAD_TEMPLATE')}
              </Link>
            )}
          {fileSizeError && (
            <p className="file-size-error-text">{fileSizeError}</p>
          )}
        </div>
        {selectedClinic && showOverrideConfirmation ? (
          <div className={'helper-text'}>
            <div className={'radio-group-text'}>
              {t('DUE_INVOICES.IMPORT_STATEMENT_CONFIRMATION_TEXT')}
            </div>
            <div>
              <RadioGroup
                row
                aria-label="gender"
                className={'radio-group-buttons'}
                name="override"
                style={{
                  margin: '0 0 1rem 0.5rem'
                }}>
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() => {
                        handleSelectedRadio('yes');
                      }}
                      value={'yes'}
                    />
                  }
                  label={HelperUtils.captilizeFirstLetter(
                    t('DUE_INVOICES.REPLACE')
                  )}
                />
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() => {
                        handleSelectedRadio('no');
                      }}
                      value={'no'}
                    />
                  }
                  label={HelperUtils.captilizeFirstLetter(
                    t('DUE_INVOICES.APPEND')
                  )}
                />
              </RadioGroup>
            </div>
          </div>
        ) : (
          selectedClinic &&
          importType === IMPORT_TYPES.STATEMENTS && (
            <div className={'helper-text'}>
              {t('DUE_INVOICES.IMPORT_STATEMENT_WARNING')}
            </div>
          )
        )}
      </div>
    );
  };

  const showConfirmationStatementDialog = () => {
    return (
      <ConfirmationDialog
        open={openDialog}
        loader={loader}
        onClose={response => {
          if (response === 'confirm') {
            handleClose('confirm');
          } else if (response === 'cancel') {
            setOpenDialog(false);
          }
        }}
        confirmButtonText={
          !overrideStatement
            ? t('ADD_PATIENT.PLACEHOLDERS.YES')
            : t('COMMON.CONFIRM')
        }
        cancelButtonText={
          !overrideStatement
            ? t('ADD_PATIENT.PLACEHOLDERS.NO')
            : t('COMMON.CANCEL')
        }
        title={t('DUE_INVOICES.CONFIRMATION_STATEMENT_TITLE', {
          value:
            overrideStatement === 'yes'
              ? HelperUtils.captilizeFirstLetter(t('DUE_INVOICES.REPLACE'))
              : overrideStatement === 'no'
              ? HelperUtils.captilizeFirstLetter(t('DUE_INVOICES.APPEND'))
              : t('DUE_INVOICES.UPLOAD_NEW')
        })}
        description={
          !overrideStatement
            ? t('DUE_INVOICES.UPLOAD_NEW_STATEMENT', {
                value: selectedClinic?.cancel_copay_statement
                  ? t('DUE_INVOICES.CANCEL_COPAY_ENABLE')
                  : ''
              })
            : t('DUE_INVOICES.CONFIRMATION_STATEMENT_SUB_TITLE', {
                value:
                  overrideStatement === 'yes'
                    ? t('DUE_INVOICES.REPLACE')
                    : t('DUE_INVOICES.APPEND'),
                cancel_copay: selectedClinic?.cancel_copay_statement
                  ? t('DUE_INVOICES.CANCEL_COPAY_ENABLE')
                  : ''
              })
        }
      />
    );
  };
  const handleConfirm = () => {
    if (importedFile) {
      if (showOverrideConfirmation && overrideStatement === '') {
        enqueueSnackbar(
          t('DUE_INVOICES.RADIO_BUTTON_VALIDATION'),
          SnackBarConfig('e')
        );
      } else if (importType === IMPORT_TYPES.STATEMENTS) {
        if (selectedClinic && Object.keys(selectedClinic).length) {
          setOpenDialog(true);
        } else {
          if (
            consolidatedBillingGroupEnable &&
            billingClinicId &&
            showBillingPractice &&
            clinics.length > 0
          ) {
            enqueueSnackbar(
              t('DUE_INVOICES.ERRORS.NO_BILLING_CLINIC_ACCESS'),
              SnackBarConfig('e')
            );
          } else {
            enqueueSnackbar(
              t('DUE_INVOICES.SELECT_A_CLINIC'),
              SnackBarConfig('e')
            );
          }
        }
      } else {
        handleClose('confirm');
      }
    } else {
      enqueueSnackbar(
        t('DUE_INVOICES.ERRORS.IMPORT_FILES'),
        SnackBarConfig('e')
      );
    }
  };
  return (
    <Dialog
      maxWidth={'sm'}
      fullWidth={true}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
      aria-describedby="confirm-dialog"
      className="import-dialog-wrapper">
      <DialogTitle disableTypography>{title}</DialogTitle>
      <DialogContent dividers>
        <div>
          <div className="sub-title">{subtitle}</div>
          {importType === IMPORT_TYPES.FNPD && (
            <Link
              component="button"
              // variant="body2"
              style={{marginTop: '0.5rem'}}
              onClick={handleDownloadFNPDTemplate}>
              {t('PATIENTS.DOWNLOAD_FN_PD_TEMPLATE')}
            </Link>
          )}
        </div>
        {renderBody()}
      </DialogContent>
      <DialogActions style={{display: 'flex'}}>
        <Button
          onClick={() => {
            handleClose('cancel');
          }}
          disabled={loader}>
          {cancelButtonText || t('COMMON.CANCEL')}
        </Button>
        <Button
          variant={'contained'}
          onClick={() => {
            handleConfirm();
          }}
          disabled={loader || !!fileSizeError}
          color="primary">
          {loader ? <Loader /> : confirmButtonText || t('COMMON.IMPORT')}
        </Button>
      </DialogActions>
      {openDialog && showConfirmationStatementDialog()}
    </Dialog>
  );
};

export default ImportFileDialog;
